import ActionNav from 'core-lib/components/actionNav/ActionNav.vue'

export default {
  name: 'terms',
  components: {
    ActionNav
  },
  methods: {
    back: function () {
      this.$router.push('/')
    }
  }
}
